import createReactComponent from '../createReactComponent';
var Axis3d = createReactComponent('Axis3d', [['path', {
  d: 'M4 4v16h16',
  key: '1s015l'
}], ['path', {
  d: 'm4 20 7-7',
  key: '17qe9y'
}]]);
export default Axis3d;